<!--  -->
<template>
  <div class="container" id="timeline-contianer">
    <img class="title" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/title.png" data-wd="168" data-left="847" data-top="145" />
    <img class="live-btn" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/btn.png" @click="openMp4" />
    <img class="logo" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/2/logo.png" />
    <img class="timeline" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/2/timeline.png" data-wd="833" data-left="880" data-top="164" />
    <img @click="show(1)" class="cursor-pointer state1" :class="{ ani4: activeIndex === 1 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/1.png" />
    <img @click="show(2)" class="cursor-pointer state2" :class="{ ani4: activeIndex === 2 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/2.png" />
    <img @click="show(3)" class="cursor-pointer state3" :class="{ ani4: activeIndex === 3 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/3.png" />
    <img @click="show(4)" class="cursor-pointer state4" :class="{ ani4: activeIndex === 4 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/4.png" />
    <img @click="show(5)" class="cursor-pointer state5" :class="{ ani4: activeIndex === 5 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/5.png" />
    <img @click="show(6)" class="cursor-pointer state6" :class="{ ani4: activeIndex === 6 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/6.png" />
    <img @click="show(7)" class="cursor-pointer state7" :class="{ ani4: activeIndex === 7 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/7.png" />
    <img @click="show(8)" class="cursor-pointer state8" :class="{ ani4: activeIndex === 8 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/8.png" />
    <img @click="show(9)" class="cursor-pointer state9" :class="{ ani4: activeIndex === 9 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/9.png" />
    <img @click="show(10)" class="cursor-pointer state10" :class="{ ani4: activeIndex === 10 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/10.png" />
    <img @click="show(11)" class="cursor-pointer state11" :class="{ ani4: activeIndex === 11 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/11.png" />
    <img @click="show(12)" class="cursor-pointer state12" :class="{ ani4: activeIndex === 12 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/12.png" />
    <img @click="show(13)" class="cursor-pointer state13" :class="{ ani4: activeIndex === 13 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/13.png" />
    <img @click="show(14)" class="cursor-pointer state14" :class="{ ani4: activeIndex === 14 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/14.png" />
    <img @click="show(15)" class="cursor-pointer state15" :class="{ ani4: activeIndex === 15 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/15.png" />
    <img @click="show(16)" class="cursor-pointer state16" :class="{ ani4: activeIndex === 16 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/16.png" />
    <img @click="show(17)" class="cursor-pointer state17" :class="{ ani4: activeIndex === 17 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/17.png" />
    <img @click="show(18)" class="cursor-pointer state18" :class="{ ani4: activeIndex === 18 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/18.png" />
    <img @click="show(19)" class="cursor-pointer state19" :class="{ ani4: activeIndex === 19 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/19.png" />
    <img @click="show(20)" class="cursor-pointer state20" :class="{ ani4: activeIndex === 20 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/20.png" />
    <img @click="show(21)" class="cursor-pointer state21" :class="{ ani4: activeIndex === 21 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/21.png" />
    <img @click="show(22)" class="cursor-pointer state22" :class="{ ani4: activeIndex === 22 }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/state/22.png" />
    <div class="swiper-container" id="timelin-swiper-container">
      <div class="swiper-wrapper swiper-no-swiping">
        <div class="swiper-slide">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/1.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/2.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/3.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/4.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/5.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/6.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/7.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/8.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/9.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/10.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/11.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/12.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/13.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/14.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/15.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/16.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/17.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/18.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/19.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/20.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/21.png" />
        </div>
        <div class="swiper-slide swiper-no-swiping">
          <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/pic/22_2.jpg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const liveUrls = [
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/221124jtqfb.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/221125jtwfb1.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/221125wtwfb2.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/20221212jwwfb.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/20221213wfbu.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/12%E6%9C%8814%E6%97%A5.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/f9859745619a40d2bfc188cdeb24bbe1_1980_1080.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/ec6af6b03424464cbed030b0f5c13b4c_1980_1080.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/360c02465df942658cd427fe458d8406_1980_1080.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/90f0754d62284e3aa5163f89ce2fe8d7_1080p4m.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/3cac0b918f154eb28af1327ebb73cd99_720p.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/13864e0b159b4db8a828e7034f163187_1980_1080.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/0c01aa3107654cc099ce0e64c4654a89_1980_1080.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/131532fda82245c19c46f62fdab3ca93_1980_1080.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/b70345e1d51149d2b310a1354254106d_720p.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/716bb576a7404ebba439c1aa70ba466e_720p.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/67f46cad80a94817a978eef05c7c63d0_1980_1080.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/55742f98e4ef4080898813379946dc7a_720p.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/c3be5f640c6b47999a7c5128d9931451_720p.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/d2d7892d75b44bd999ebc840a4c0a3ba_720p.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/da8d643e902411ee95ead63720c9b3c6.mp4',
  'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/0-aqes_33776.aqes0.1703754950.mp4'
]
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Swiper from 'swiper' // 注意引入的是Swiper
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      inited: false,
      initFlag: false,
      timeLineSwiper: null,
      activeIndex: 0
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    openMp4() {
      this.$emit('openModal', {
        videoUrl: liveUrls[this.activeIndex - 1]
      })
      this.timeLineSwiper.autoplay.stop()
    },
    show(index) {
      this.activeIndex = index
      this.timeLineSwiper.autoplay.stop()
      this.timeLineSwiper.slideTo(index)
    },
    init() {
      if (this.inited) return
      this.inited = true
      setTimeout(() => {
        this.initFlag = true
        this.activeIndex = 1
        this.timeLineSwiper.autoplay.start()
      }, 1000)
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.timeLineSwiper = new Swiper('#timelin-swiper-container', {
      spaceBetween: 0,
      loop: true,
      loopFillGroupWithBlank: true,
      autoplay: false,
      observer: true,
      observeParents: true,
      autoplayDisableOnInteraction: false,
      on: {
        transitionStart: () => {
          if (!this.initFlag) return
          if (this.timeLineSwiper) {
            if (this.timeLineSwiper.activeIndex >= 23 || this.timeLineSwiper.activeIndex === 1) {
              this.activeIndex = 1
            } else {
              this.activeIndex = this.timeLineSwiper.activeIndex
            }
          }
        }
      }
    })
    // this.timeLineSwiper.autoplay.stop()
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
$originWidth: 1920;
$originHeight: 919;
.container {
  background-image: url('https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/919/bg.jpg'); /* 替换成你的图片地址 */
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
  overflow: hidden;

  #timelin-swiper-container {
    position: absolute;
    width: percentage(618 / $originWidth);
    height: percentage(409 / $originHeight);
    left: percentage(94 / $originWidth);
    top: percentage(303 / $originHeight);
    border: 4px solid #ffee9e;
    background-color: #fff;
    box-shadow: 5.29px 7.281px 29px 0px rgba(129, 42, 25, 0.54);
    border-radius: 52px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .title {
    position: absolute;
    width: percentage(158 / $originWidth);
    height: percentage(26 / $originHeight);
    left: percentage(927 / $originWidth);
    top: percentage(93 / $originHeight);
  }
  .live-btn {
    position: absolute;
    width: percentage(613 / $originWidth);
    height: percentage(41 / $originHeight);
    left: percentage(96 / $originWidth);
    top: percentage(763 / $originHeight);
  }
  .logo {
    position: absolute;
    width: percentage(268 / $originWidth);
    height: percentage(139 / $originHeight);
    left: percentage(99 / $originWidth);
    top: percentage(164 / $originHeight);
  }
  .timeline {
    position: absolute;
    width: percentage(956 / $originWidth);
    height: percentage(754 / $originHeight);
    left: percentage(939 / $originWidth);
    top: percentage(101 / $originHeight);
  }
  .state1 {
    position: absolute;
    width: percentage(206 / $originWidth);
    height: percentage(63 / $originHeight);
    left: percentage(868 / $originWidth);
    top: percentage(253 / $originHeight);
  }
  .state2 {
    position: absolute;
    width: percentage(216 / $originWidth);
    height: percentage(63 / $originHeight);
    left: percentage(868 / $originWidth);
    top: percentage(342 / $originHeight);
  }
  .state3 {
    position: absolute;
    width: percentage(206 / $originWidth);
    height: percentage(63 / $originHeight);
    left: percentage(868 / $originWidth);
    top: percentage(432 / $originHeight);
  }
  .state4 {
    position: absolute;
    width: percentage(248 / $originWidth);
    height: percentage(65 / $originHeight);
    left: percentage(868 / $originWidth);
    top: percentage(520 / $originHeight);
  }
  .state5 {
    position: absolute;
    width: percentage(276 / $originWidth);
    height: percentage(65 / $originHeight);
    left: percentage(868 / $originWidth);
    top: percentage(610 / $originHeight);
  }
  .state6 {
    position: absolute;
    width: percentage(248 / $originWidth);
    height: percentage(64 / $originHeight);
    left: percentage(868 / $originWidth);
    top: percentage(700 / $originHeight);
  }
  .state7 {
    position: absolute;
    width: percentage(276 / $originWidth);
    height: percentage(64 / $originHeight);
    left: percentage(1182 / $originWidth);
    top: percentage(700 / $originHeight);
  }
  .state8 {
    position: absolute;
    width: percentage(276 / $originWidth);
    height: percentage(65 / $originHeight);
    left: percentage(1182 / $originWidth);
    top: percentage(611 / $originHeight);
  }
  .state9 {
    position: absolute;
    width: percentage(248 / $originWidth);
    height: percentage(66 / $originHeight);
    left: percentage(1182 / $originWidth);
    top: percentage(520 / $originHeight);
  }
  .state10 {
    position: absolute;
    width: percentage(304 / $originWidth);
    height: percentage(65 / $originHeight);
    left: percentage(1182 / $originWidth);
    top: percentage(432 / $originHeight);
  }
  .state11 {
    position: absolute;
    width: percentage(248 / $originWidth);
    height: percentage(63 / $originHeight);
    left: percentage(1182 / $originWidth);
    top: percentage(344 / $originHeight);
  }
  .state12 {
    position: absolute;
    width: percentage(248 / $originWidth);
    height: percentage(64 / $originHeight);
    left: percentage(1182 / $originWidth);
    top: percentage(255 / $originHeight);
  }
  .state13 {
    position: absolute;
    width: percentage(276 / $originWidth);
    height: percentage(65 / $originHeight);
    left: percentage(1182 / $originWidth);
    top: percentage(164 / $originHeight);
  }
  .state14 {
    position: absolute;
    width: percentage(439 / $originWidth);
    height: percentage(65 / $originHeight);
    left: percentage(1182 / $originWidth);
    top: percentage(76 / $originHeight);
  }
  .state15 {
    position: absolute;
    width: percentage(248 / $originWidth);
    height: percentage(65 / $originHeight);
    left: percentage(1524 / $originWidth);
    top: percentage(164 / $originHeight);
  }
  .state16 {
    position: absolute;
    width: percentage(288 / $originWidth);
    height: percentage(64 / $originHeight);
    left: percentage(1524 / $originWidth);
    top: percentage(254 / $originHeight);
  }
  .state17 {
    position: absolute;
    width: percentage(216 / $originWidth);
    height: percentage(63 / $originHeight);
    left: percentage(1524 / $originWidth);
    top: percentage(344 / $originHeight);
  }
  .state18 {
    position: absolute;
    width: percentage(216 / $originWidth);
    height: percentage(64 / $originHeight);
    left: percentage(1524 / $originWidth);
    top: percentage(432 / $originHeight);
  }
  .state19 {
    position: absolute;
    width: percentage(206 / $originWidth);
    height: percentage(65 / $originHeight);
    left: percentage(1524 / $originWidth);
    top: percentage(520 / $originHeight);
  }
  .state20 {
    position: absolute;
    width: percentage(206 / $originWidth);
    height: percentage(65 / $originHeight);
    left: percentage(1524 / $originWidth);
    top: percentage(610 / $originHeight);
  }
  .state21 {
    position: absolute;
    width: percentage(216 / $originWidth);
    height: percentage(64 / $originHeight);
    left: percentage(1524 / $originWidth);
    top: percentage(700 / $originHeight);
  }

  .state22 {
    position: absolute;
    width: percentage(275 / $originWidth);
    height: percentage(63 / $originHeight);
    left: percentage(1524 / $originWidth);
    top: percentage(786 / $originHeight);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TimeLine/index.vue